import { HostBinding, Input, Directive } from '@angular/core';
import {ButtonPositionEnum} from '@shared/modules/buttons/enums/button-position.enum';

@Directive()
export abstract class AbstractButtonComponent {
  @HostBinding('style.display') @Input() display: string = 'inline-flex';

  @Input() classname: string = 'btn-primary';
  @Input() shadow: boolean = true;
  @Input() position: ButtonPositionEnum = ButtonPositionEnum.Right;
}
